/* swt-header-more.js · SWT Header v2.9 (10-08-26): long menus on desktop
   (990px and up). Step 1: normal spacing. Step 2: compact spacing
   (.swt-nav.is-compact, same sizes as the 990-1099px rules in
   swt-header-menu.css). Step 3: items that still do not fit move into the
   "More" dropdown at the end of the row, starting from the right (so the
   right-side service links go first). Highlighted items (e.g. The Vault)
   and the first item are moved last. The dropdown is rendered by
   snippets/swt-header-nav.liquid with one hidden entry per nav item; this
   file shows the entries whose item is hidden, in menu order. More is
   marked current when the page you are on is one of the moved items. The
   divider before the right-side links hides when none of them is left.
   Runs on load, on resize and when web fonts finish loading. When every
   item fits, nothing changes, so a short menu looks exactly as before.
   Module for swt-header.js (registered on window.SWTHeaderModules, so this
   file loads before swt-header.js). */
(function () {
  'use strict';
  var mods = window.SWTHeaderModules = window.SWTHeaderModules || [];

  mods.push(function (ctx) {
    var root = ctx.root, sig = ctx.sig;
    var ul = root.querySelector('.swt-nav');
    var more = ul && ul.querySelector('[data-swt-more]');
    if (!ul || !more) return;

    var items = Array.prototype.filter.call(ul.children, function (li) {
      return li.hasAttribute('data-nav-i');
    });
    var sep = ul.querySelector('[data-swt-sep]');
    var utils = items.filter(function (li) { return li.classList.contains('swt-nav__item--util'); });
    var entries = {};
    Array.prototype.forEach.call(more.querySelectorAll('[data-more-for]'), function (e) {
      entries[e.getAttribute('data-more-for')] = e;
    });

    /* who moves first: from the right, highlighted items last, never the first item */
    var rest = items.slice(1).reverse();
    var order = rest.filter(function (li) { return !li.classList.contains('swt-nav__item--hot'); })
      .concat(rest.filter(function (li) { return li.classList.contains('swt-nav__item--hot'); }));

    var mq = window.matchMedia('(min-width: 990px)');
    var raf = 0, ro = null;

    function fits() { return ul.scrollWidth <= ul.clientWidth + 1; }

    function syncSep() {
      if (!sep) return;
      sep.hidden = !utils.some(function (li) { return !li.classList.contains('is-overflow'); });
    }

    function setOver(li, on) {
      li.classList.toggle('is-overflow', on);
      var e = entries[li.getAttribute('data-nav-i')];
      if (e) e.hidden = !on;
    }

    function fit() {
      raf = 0;
      ul.classList.remove('is-compact');
      more.hidden = true;
      more.classList.remove('is-current');
      items.forEach(function (li) { setOver(li, false); });
      syncSep();
      if (mq.matches && !fits()) {
        ul.classList.add('is-compact');
        if (!fits()) {
          more.hidden = false;
          var cur = false;
          for (var i = 0; i < order.length && !fits(); i++) {
            setOver(order[i], true);
            syncSep();
            if (order[i].classList.contains('is-current')) cur = true;
          }
          more.classList.toggle('is-current', cur);
          /* stagger index for the visible entries, in menu order */
          var k = 0;
          items.forEach(function (li) {
            var e = entries[li.getAttribute('data-nav-i')];
            if (e && !e.hidden) e.style.setProperty('--i', k++);
          });
        }
      }
      /* an open menu whose item just moved into More closes */
      if (ul.querySelector('.swt-nav__item.is-open.is-overflow') && ctx.closeMenu) ctx.closeMenu();
    }

    function queue() { if (!raf) raf = requestAnimationFrame(fit); }

    fit();
    window.addEventListener('resize', queue, sig);
    mq.addEventListener('change', queue, sig);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(queue);
      ro.observe(ul.parentNode);
    }

    return function () {
      if (raf) cancelAnimationFrame(raf);
      if (ro) ro.disconnect();
    };
  });
})();
